import type { NeonHttpDatabase as Database } from "drizzle-orm/neon-http";
import type * as schema from "../../drizzle/schema";
import type * as relations from "../../drizzle/relations";
import { configureDb } from "./db-middleware";

export type DrizzleDB = Database<typeof schema & typeof relations>;

export const getDB = (): DrizzleDB => {
  if (!globalThis.db) {
    console.error("DB is not initialized. Call configureDb() first.");
    console.log(new Error().stack);
    throw new Error("DB is not initialized. Call configureDb() first.");
  }

  return globalThis.db;
};

export const getDBWithInit = async (): Promise<DrizzleDB> => {
  await configureDb();
  return getDB();
};
